<template>
  <div>
    <div class="login_bg cloud-auth-bg"></div>

    <b-overlay
      id="overlay-background"
      :show="loading"
      opacity="0.6"
      style="width: 100%;"
      spinner-variant="primary"
    >
      <div class="auth-wrapper auth-v1 px-2">
        <div class="auth-inner py-2">
          <!-- Login v1 -->
          <b-card class="mb-0 loginbox">
            <b-card-title class="mb-1 mt-2">
              {{ data.mhy_open_id ? "关联开放平台账号" : "梦幻云平台" }}
            </b-card-title>

            <!-- form -->
            <validation-observer ref="loginForm">
              <b-form class="auth-login-form mt-2" @submit.prevent="login">
                <!-- email -->
                <b-form-group label-for="account" label="用户名">
                  <b-form-input
                    id="account"
                    v-model="data.account"
                    name="account"
                    placeholder="请输入用户名"
                    autofocus
                  />
                </b-form-group>

                <!-- password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="password">密码</label>
                    <b-link
                      :to="{ name: 'auth-forgot-password-v1' }"
                      tabindex="-1"
                      v-if="false"
                    >
                      <small>忘记密码?</small>
                    </b-link>
                  </div>

                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="password"
                      v-model="data.password"
                      :type="passwordFieldType"
                      class="form-control-merge"
                      name="login-password"
                      placeholder="请输入密码"
                    />

                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>

                <!-- checkbox -->
                <b-form-group>
                  <b-form-checkbox
                    id="remember-me"
                    v-model="status"
                    name="checkbox-1"
                  >
                    记住密码
                  </b-form-checkbox>
                </b-form-group>

                <!-- submit button -->
                <b-button type="submit" variant="primary" block>
                  {{ data.mhy_open_id ? "关联账号" : "登录" }}
                </b-button>
              </b-form>
            </validation-observer>

            <b-card-text v-if="false" class="text-center mt-2">
              <span>没有账号? </span>
              <b-link @click="register">
                <span>创建账号</span>
              </b-link>
            </b-card-text>

            <div class="divider my-1" v-if="!data.mhy_open_id">
              <div class="divider-text">
                or
              </div>
            </div>
            <!-- social button -->
            <div
              class="auth-footer-btn d-flex justify-content-center"
              v-if="!data.mhy_open_id"
            >
              <a href="javascript:void(0)" style="" @click="open">
                <img
                  style="width: 2rem;height: 2rem;"
                  src="../assets/images/weixin.png"
                />
              </a>
            </div>
          </b-card>
          <!-- /Login v1 -->
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BOverlay,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";

function toBase64(str) {
  return btoa(unescape(encodeURIComponent(str || "")));
}

function fromBase64(b64) {
  try {
    return decodeURIComponent(escape(atob(b64 || "")));
  } catch (e) {
    return "";
  }
}
export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: false,
      loading: false,
      data: {
        account: "",
        password: "",
      },
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  mounted() {
    var openid = this.$route?.query?.openid;
    if (openid) {
      this.data.mhy_open_id = openid;
      this.$forceUpdate();
      console.log(this.data);
    }

    const saved = localStorage.getItem("logininfo");
    if (saved) {
      try {
        const p = JSON.parse(fromBase64(saved));
        this.data.account = p.account || "";
        this.data.password = p.password || "";
        this.status = true;
      } catch (e) {}
    }
  },
  methods: {
    login() {
      const shouldRemember = this.status;
      this.loading = true;
      this.$http
        .post("/Account/Login", this.$transformRequest(this.data))
        .then((u) => {
          this.loading = false;
          this.$setToken(u);

          if (shouldRemember) {
            localStorage.setItem(
              "logininfo",
              toBase64(
                JSON.stringify({
                  account: this.data.account,
                  password: this.data.password,
                })
              )
            );
          } else {
            localStorage.removeItem("logininfo");
          }

          this.data = {
            account: "",
            password: "",
          };
          this.$successAlert("登录成功");
          this.$router.replace({
            name: "home",
          });
        })
        .catch((u) => {
          this.loading = false;
          localStorage.removeItem("logininfo");
        });
    },
    open() {
      this.loading = true;
      const baseUrl = window.location.origin;
      var redirect_uri = baseUrl + "/AuthCallback";
      this.$http
        .get(`/Account/CreateAuthUrl?redirect_uri=${redirect_uri}`)
        .then((u) => {
          this.loading = false;
          top.window.location.href = u;
        })
        .catch((u) => {
          this.loading = false;
        });
    },
    register() {
      this.$router.push({
        name: "Register",
        query: {
          openid: this.data.mhy_open_id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.auth-wrapper.auth-v1 {
  transform: translateY(-4rem);
}
.loginbox {
    border: none;
    margin-bottom: 2rem;
}
</style>
